<template>
  <div class="check-work-body">
    <div>
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
      </div>

      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
          <el-table-column prop="model_id" label="id" align="center"></el-table-column>
          <el-table-column prop="model_name" label="模型名称" align="center" width="240"></el-table-column>
          <el-table-column prop="model_table" label="数据库表名" align="center" width="240"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="50">
            <template slot-scope="scope">
              {{scope.row.status?'显示':'隐藏'}}
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="创建时间" align="center" width="180"></el-table-column>
          <el-table-column prop="update_time" label="修改时间" align="center" width="180"></el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <router-link :to="{path:'/flow/FlowModelDetail',query: {model_id: scope.row.model_id}}">
                <el-button type="primary" size="mini" icon="el-icon-s-order">编辑</el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="添加" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="模型名称" prop="title">
            <el-input class="form-input" v-model="form.model_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="数据库表名" prop="title">
            <el-input class="form-input" v-model="form.model_table" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="模型分类" prop="title">
            <el-input class="form-input" v-model="form.category_id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="title">
            <el-radio v-model="form.status" label="1">显示</el-radio>
            <el-radio v-model="form.status" label="0">隐藏</el-radio>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import Http from "./common/Http";

export default {
  name:"FlowModelList",
  data () {
    return {
      keyword: '',
      dialogVisible: false,
      loading: false,
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      form:{
        model_name:"",
        model_table:"",
        status:1,
        category_id: "",
        create_time: "",
        edit_time: "",
      },
    }
  },
  created() {
    this.getList()
  },
  activated() {

  },
  watch: {

  },
  methods: {
    editArticle() {
      this.dialogVisible = true
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      Http.get("flow/FlowModel/getModelList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          console.log(data)
          Http.post("flow/FlowModel/saveModel",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowModelList.vue